import React from "react";

const ASP_Examples = () => {
  return (
    <div className="tutorial-page">
      <h1>ASP Examples</h1>
      <p>This is the ASP Examples page content.</p>
    </div>
  );
};

export default ASP_Examples;
